import { TranslateLoader } from '@ngx-translate/core';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { LoggerService } from '../services/logger.service';
import { SafeAny } from '../types/safe-any';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(
    private readonly prefix: string = 'assets/i18n/',
    private readonly suffix: string = '.json',
    private readonly logger?: LoggerService
  ) { }

  getTranslation(lang: string): Observable<SafeAny> {
    const url = `${this.prefix}${lang}${this.suffix}?v=${environment.appVersion}`;

    return from(
      fetch(url, { cache: 'no-cache' })
        .then(async (response) => {
          if (!response.ok) {
            throw new Error(`Failed to load translation file: ${url} (${response.status})`);
          }

          const contentType = response.headers.get('content-type') ?? '';
          if (!contentType.includes('application/json')) {
            throw new Error(
              `Invalid translation response for ${url}: expected JSON, received ${contentType || 'unknown'}`
            );
          }

          return response.json();
        })
        .catch((error) => {
          if (this.logger) {
            this.logger.error(`Error loading translation file ${url}:`, error);
          } else {
            console.error(`Error loading translation file ${url}:`, error);
          }
          return {};
        })
    ).pipe(map((translations) => translations ?? {}));
  }
}

export function provideCustomTranslateLoader(
  prefix: string = 'assets/i18n/',
  suffix: string = '.json'
) {
  return {
    provide: TranslateLoader,
    useFactory: (logger: LoggerService) => new CustomTranslateLoader(prefix, suffix, logger),
    deps: [LoggerService],
  };
}
